type Loader = {
  load: (searchText?: string) => Promise<any[]>
}

const fetchDataToInput = async (loader: Loader, searchText?: string): Promise<any[]> => {
  try {
    const response = await loader.load(searchText)
    return toInputData(response)
  } catch (error) {
    return []
  }
}

export default fetchDataToInput

export const toInputData = (data: any[]): any[] => {
  return data.map(item => ({
    value: item.id,
    label: item.name || item.user?.completeData,
    customLabel: item.user?.email,
    hierarchyLatitude: item.hierarchyLatitude,
    hierarchyLongitude: item.hierarchyLongitude
  }))
}
